import React from 'react';
const MoreSvg = ({ color = 'white', className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 8C7.5 8.27614 7.72386 8.5 8 8.5C8.27614 8.5 8.5 8.27614 8.5 8C8.5 7.72386 8.27614 7.5 8 7.5C7.72386 7.5 7.5 7.72386 7.5 8Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M11.5 8C11.5 8.27614 11.7239 8.5 12 8.5C12.2761 8.5 12.5 8.27614 12.5 8C12.5 7.72386 12.2761 7.5 12 7.5C11.7239 7.5 11.5 7.72386 11.5 8Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M3.5 8C3.5 8.27614 3.7239 8.5 4 8.5C4.2761 8.5 4.5 8.27614 4.5 8C4.5 7.72386 4.2761 7.5 4 7.5C3.7239 7.5 3.5 7.72386 3.5 8Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default MoreSvg;
